export default __webpack_public_path__ + "static/media/factory__43.449a662d.jpg";